import { enumOrderStatusType } from '../../../_metronic/helpers';

export const orderStatusFlow = [
    enumOrderStatusType.New,
    enumOrderStatusType.CustomOrderReceived,
    enumOrderStatusType.PaymentCallPending,
    enumOrderStatusType.PaymentPending,
    enumOrderStatusType.Created,
    enumOrderStatusType.Approved,
    enumOrderStatusType.Preparing,
    enumOrderStatusType.Ready,
    enumOrderStatusType.Shipped,
    enumOrderStatusType.Delivered,
];

export const cancelledStatus = enumOrderStatusType.Cancelled;

export const OrderConditionType = {
    AllItemsReady: 'AllItemsReady',
    DigitalSignature: 'DigitalSignature',
    PhotosAdded: 'PhotosAdded'
};
